import { h, Component } from 'preact'

interface Props {
  children: string
}

export default class extends Component<Props> {
  render ({ children }: Props) {
    return (
      <form className='m-form'>
        {children}
      </form>
    )
  }
}
